 
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
 
import NavFot from './component/Main/NavFot';
import Main from './component/Main/Main';
import OurWorks from './component/Pages/OurWorks';
import ContactUs from './component/Pages/ContactUs';
import Service from './component/Pages/Service';
import AboutUs from './component/Pages/AboutUs';
import ScrollToTop from './ScrollToTop';
function App() {
  return (
 <BrowserRouter>
 <ScrollToTop/>
 <Routes>
  <Route path="/" element={<NavFot/>}>
  <Route index element={<Main/>}/>
  <Route path="our-works" element={<OurWorks/>}/>
  <Route path="contact"element={<ContactUs/>}/>
  <Route path="services"element={<Service/>}/>
  <Route path="about"element={<AboutUs/>}/>



  </Route>
 </Routes>
 </BrowserRouter>
  );
}

export default App;
